/**
 * Object key order is not guarenteed. This can be useful
 * but should not be depended upon.
 */
export const sortObject = (obj) => {
    // Convert object to array of key-value pairs
    const arr = Object.entries(obj);
    // Sort array by key
    arr.sort(([key1], [key2]) => key1.localeCompare(key2));
    // Convert array back to object
    return Object.fromEntries(arr);
};
